import $http from '$http'
import {
    lg,
    cloneDeep,
    util,
    isCorrectVal,
    isDate
} from 'utils';

export default {
    methods: {
        Kingdee_ParagraphAdd(param) {
            if (param.ParagraphType == 1) {
                var href = 'api/Kingdee/Kingdee_ParagraphAdd'
            } else {
                var href = 'api/Kingdee/AgentAccount_Kingdee_ParagraphAdd'
            }
            $http.post(href, param).then(res => {
                util.doResult(this, res, () => {
                    this.$notify({
                        title: '成功',
                        message: '成功确认！',
                        type: 'success'
                    });
                    this.KingdeeAddForm = this.getKingdeeAddData();
                    this.dialogVisible = false;

                });
            });
        },
    }
};


// WEBPACK FOOTER //
// ./src/pages/CRMAgentAccountManage/components/returnMoney/services.js